import getCommandMetadata from './getCommandMetadata';

export default getCommandMetadata;
